import React from 'react';
import { Result, Button } from 'antd';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            unhandledErrorInfo: null,
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            unhandledErrorInfo: {
                error,
                errorInfo,
            },
        });
    }
    render() {
        const { unhandledErrorInfo } = this.state;
        if (unhandledErrorInfo &&
            (unhandledErrorInfo.error.stack.indexOf('ChunkLoadError') > -1 ||
                unhandledErrorInfo.error.stack.indexOf('Loading CSS chunk') > -1)) {
            return (<Result status="error" title="There is something wrong with your network." extra={<Button type="primary" onClick={() => {
                        window.location.reload();
                    }}>
              Try to refresh page
            </Button>}/>);
        }
        if (unhandledErrorInfo) {
            return (<Result status="error" title="Sorry, something went wrong. please take a screenshot of the page and send it to the developer" subTitle={<div style={{ textAlign: 'left' }}>
              <h3>error stack:</h3>
              <p>{unhandledErrorInfo.error.stack}</p>
              <br />
              <h3>component stack:</h3>
              <p>{unhandledErrorInfo.errorInfo.componentStack}</p>
            </div>} extra={<Button type="primary" onClick={() => {
                        window.localStorage.clear();
                        window.location.reload();
                    }}>
              Try to clear the data cache to fix
            </Button>}/>);
        }
        return this.props.children;
    }
}
export { Result, ErrorBoundary };
